import withAnimation from 'HOCs/withAnimation';
import React from 'react';
import { sharedlinks } from 'shared-links';
import lines from 'assets/images/lines.svg';
import stars from 'assets/images/stars.svg';
import { avatars } from 'assets/avatars';

const Hero = () => {
  return (
    <section className="mx-auto max-w-screen-xl pb-4 px-4 my-10 sm:px-8 md:my-24">
      <div className="relative text-center space-y-4">
        <h1 className="text-light font-bold text-4xl md:text-6xl">
          Make your Twitter & LinkedIn profiles <br />
          <span className="relative text-primary">
            stand out <img src={lines} className="absolute left-10 -bottom-1" alt="underline" />
          </span>
          with Bafancy banners
        </h1>
      </div>
      <div className="mt-12 flex flex-col gap-2 justify-center items-center md:flex-row md:gap-6">
        <a
          className="primary-btn w-full md:w-fit"
          href={sharedlinks.waitlist}
          target="blank"
          rel="noreferrer">
          Try for free
        </a>
      </div>
      <div className="mt-10 mx-auto w-fit">
        <div className="flex justify-center items-center bg-secondary p-3 rounded-full">
          {avatars.map((av, index) => (
            <div className="-mr-3" key={index}>
              <img src={av} className="rounded-full w-10" alt="avatar" />
            </div>
          ))}
          <img src={stars} alt="stars" className="ml-5 h-5" />
        </div>
        <div>
          <p className="text-white text-center mt-2">Join Bafancy family</p>
        </div>
      </div>
    </section>
  );
};

export default withAnimation(Hero);
